
// 构件批量移动接口错误码
export const batchUpdateErrorCodeMap = {
  'space.resource.duplicate': '无需移动'
}
